<template>
  <div id="licenseWrap">
    <div class="tabBar">
      <div class="barCont">
        <div class="barLeft" >
          <span @click="$router.push('/foodLicense/home')" style="cursor: pointer;">智能化检索</span>
        </div>
        <!-- <div class="barRight">
          <span>登陆</span>
          <div class="line"></div>
          <span>免费注册</span>
        </div> -->
      </div>
    </div>
    <div class="licContent">
      <div class="licContTop">
        <div class="search">
          <img src="../../../assets/imgs/foodLicense/食品经营许可证@2x.png" alt />
          <div class="inp">
            <!-- <el-tabs>
              <el-tab-pane label="经营者名称">
                <el-input placeholder="请输入公司名称" v-model="name"></el-input>
              </el-tab-pane>
              <el-tab-pane label="许可证编号">
                <el-input placeholder="请输入许可证编号" v-model="id"></el-input>
              </el-tab-pane>
            </el-tabs>-->
            <div>
              <span :class="currentIndex===1?'tabName active':'tabName'" @click="changeTab(1)" style="cursor: pointer;">经营者名称</span>
              <span :class="currentIndex===2?'tabName active':'tabName'" @click="changeTab(2)" style="cursor: pointer;">许可证编号</span>
            </div>
            <div>
              <input
                placeholder="请输入公司名称"
                v-model="name"
                :class="currentIndex===1?'tabInput active':'tabInput'"
              />
              <button @click="searchName" v-show="nameShow" style="cursor: pointer;">检索</button>
              <input
                placeholder="请输入许可证编号"
                v-model="id"
                :class="currentIndex===2?'tabInput active':'tabInput'"
              />
              <button @click="searchId" v-show="idShow" style="cursor: pointer;">检索</button>
            </div>
          </div>
        </div>
        <div class="licForm">
          <div class="conditions">
            <span>已选条件：</span>
            <ul>
              <li v-show="addr !== ''">
                所属地区：{{addr}}
                <i @click="addrCls">
                  <img src="../../../assets/imgs/foodLicense/close@2x.png" alt  style="cursor: pointer;"/>
                </i>
              </li>
              <li v-show="date !== ''">
                发证年份：{{date}}
                <i @click="dataCls">
                  <img src="../../../assets/imgs/foodLicense/close@2x.png" alt   style="cursor: pointer;"/>
                </i>
              </li>
              <li v-show="mats !== ''">
                主业状态：{{mats}}
                <i @click="matsCls">
                  <img src="../../../assets/imgs/foodLicense/close@2x.png" alt  style="cursor: pointer;"/>
                </i>
              </li>
              <li v-show="status !== ''">
                当前状态:{{status}}
                <i @click="statusCls">
                  <img src="../../../assets/imgs/foodLicense/close@2x.png" alt  style="cursor: pointer;"/>
                </i>
              </li>
            </ul>
          </div>
          <div class="region" style="position: relative;">
            <span style="line-height: 33px">所属地区：</span>
            <ul :class=" regsMore == true ? 'showM' : '' ">
              <li
                v-for="(item,index) in region"
                :key="index"
                @click="Addr(item.key,index)"
                :class="index==isRegion?'change':''"
                style="cursor: pointer;"
              >{{item.key}}({{item.doc_count}})</li>
            </ul>
            <div
              class="more"
              style="display: inline-block; position: absolute; top: 15px; right: 0px; cursor: pointer;"
               v-show="region.length > 10"
              >
              <span style="font-weight: 400; font-size: 16px; color:rgba(102,102,102,1); font-family:PingFangSC-Regular,PingFang SC;" @click="regMore">更多</span>
              <i>
                <img
                  src="../../../assets/imgs/foodLicense/jiantou_1@2x.png"
                  alt
                  style="width:12px; height: 8px; display: inline-block"
                  :class=" regsMore == true ? 'trans' : '' "
                />
              </i>
            </div>
          </div>
          <div class="year" style="position: relative;">
            <span style="line-height: 28px;">发证年份：</span>
            <ul :class=" yearsMore == true ? 'showM' : '' ">
              <li
                v-for="(item,index) in year"
                :key="index"
                @click="Year(item.key,index)"
                :class="{ change:index==isYear }"
                style="cursor: pointer;"
              >{{item.key}}({{item.doc_count}})</li>
            </ul>
            <div
              class="more"
              style="display: inline-block; position: absolute; top: 5px; right: -20px; cursor: pointer;"
               v-show="year.length > 11"
              >
              <span style="font-weight: 400; font-size: 16px; color:rgba(102,102,102,1); font-family:PingFangSC-Regular,PingFang SC;" @click="yearMore">更多</span>
              <i>
                <img
                  src="../../../assets/imgs/foodLicense/jiantou_1@2x.png"
                  alt
                  style="width:12px; height: 8px; display: inline-block"
                  :class=" yearsMore == true ? 'trans' : '' "
                />
              </i>
            </div>
          </div>
          <div class="formats" style="position: relative;">
            <span>主体业态：</span>
            <ul :class=" showMore == true ? 'showM' : '' ">
              <li
                v-for="(item,index) in formats"
                :key="index"
                @click="Formats(item.key,index)"
                :class="{ change:index==isFormats }"
                style="cursor: pointer;"
              >{{item.key}}({{item.doc_count}})</li>
            </ul>
            <div
              class="more"
              style="display: inline-block; position: absolute; top: 0px; right: -20px; cursor: pointer;"
              v-show="formats.length > 4">
              <span style="font-weight: 400; font-size: 16px" @click="more" >更多</span>
              <i>
                <img
                  src="../../../assets/imgs/foodLicense/jiantou_1@2x.png"
                  alt
                  style="width:12px; height: 8px; display: inline-block"
                  :class=" showMore == true ? 'trans' : '' "
                />
              </i>
            </div>
          </div>
          <div class="theme">
            <span>当前状态：</span>
            <ul>
              <li @click="Status(item.key)" 
              :class="isTheme == 1 ? 'change themeLi' : 'themeLi'"
               v-for="(item,index) in statusList" :key="index"
               v-show="item.doc_count>0">
               {{item.key == 1 ? "有效" : "无效"}}({{item.doc_count}})
               </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="licContCen">
        <div class="contCen">
          <div class="result">
            <span>
              找到相关结果
              <em>{{allCount}}</em>个
            </span>
          </div>
          <div class="sort">
            <el-dropdown @command="handleCommand">
              <el-button type="primary">
                {{this.orderS}}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="默认排序">默认排序</el-dropdown-item>
                <el-dropdown-item command="发证时间升序">发证时间升序</el-dropdown-item>
                <el-dropdown-item command="发证时间降序">发证时间降序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="licContFoot">
        <el-table
          :data="tableData"
          slot="empty"
          style="width: 100%; font-size: 18px"
          v-show="this.tableData.length > 0"
          v-loading="loading">
          <el-table-column prop="license_no" label="许可证编号" align="center"></el-table-column>
          <el-table-column prop="company_name" label="经营者名称" align="center"></el-table-column>
          <el-table-column prop="pub_date" label="发证日期" width="180" align="center"></el-table-column>
          <el-table-column prop="end_date" label="有效期至" width="180" align="center"></el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <em style="color:#139EFF; font-size:18px; cursor: pointer" @click="$router.push(`licenseDetail?id=${scope.row.id}`)">查询详情</em>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper,sizes,total"
          :total="allCount"
          v-show="this.tableData.length > 0"
        ></el-pagination>
        <div class="showInfo" v-show="this.tableData.length <= 0">
          <img src="../../../assets/imgs/foodLicense/kong@2x.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { listSearch } from "@/api/foodLicense.js";
export default {
  data() {
    return {
      loading:true,
      regsMore: true,
      yearsMore:true,
      showMore: true,
      nameShow: true,
      idShow: false,
      According: true,
      imgShow: false,
      currentIndex: 1,
      tabInputList: [],
      tabNameList: [],
      // 总数
      allCount: 0,
      page: 1,
      pageSize: 10,
      isTheme: 1,
      isRegion: "",
      isYear: "",
      isFormats: "",
      currentPage: 4,
      order: "",
      orderS: "默认排序",
      status: "",
      addr: "",
      date: "",
      mats: "",
      id: "",
      name: "",
      region: [],
      year: [""],
      formats: [""],
      statusList:[""],
      tableData: []
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id && this.id !== "") {
      this.isRegion = -1;
      this.isYear = -1;
      this.isFormats = -1;
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          console.log(this.statusList,"dd")
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
        
      });
      this.currentIndex = 2;
    }
    this.name = this.$route.query.name;
    if (this.name && this.name !== "") {
      this.isRegion = -1;
      this.isYear = -1;
      this.isFormats = -1;
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.statusList,"dd")
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
      });
      this.currentIndex = 1;
    }
  },
  methods: {
    regMore() {
      if (this.region.length > 10) {
        this.regsMore = !this.regsMore;
      }
    },
    yearMore(){
      if (this.year.length > 11) {
        this.yearsMore = !this.yearsMore;
      }
    },
    more() {
      if (this.formats.length > 4) {
        this.showMore = !this.showMore;
      }

      // console.log(this.showMore);
    },
    statusCls(){
      this.status = "";
       let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
      });
      this.isRegion = -1;
    },
    addrCls() {
      this.addr = "";

      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
      });
      this.isRegion = -1;
    },
    dataCls() {
      this.date = "";

      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
      });
      this.isYear = -1;
    },
    matsCls() {
      this.mats = "";
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
      });
      this.isFormats = -1;
    },
    changeTab(index) {
      this.currentIndex = index;
      if (index == 1) {
        this.nameShow = true;
        this.idShow = false;
      } else {
        this.nameShow = false;
        this.idShow = true;
      }
    },
    handleCommand(command) {
      this.orderS = command;
      if (command == "默认排序") {
        this.order = "status desc";
      } else if (command == "发证时间升序") {
        this.order = "pub_date asc";
      } else if (command == "发证时间降序") {
        this.order = "pub_date desc";
      }
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        sort: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.isRegion = 0
        }else{
          this.tableData = []
          this.statusList = res.status_count;
        }
      });
    },
    searchName() {
      this.addr=""
      this.date=''
      this.mats=''
      this.status=''
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: "", // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        } else {
          this.tableData = [];
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
        }
      });
    },
    searchId() {
      this.addr=""
      this.date=''
      this.mats=''
      this.status=''
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: "", // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading =false
        } else {
          this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
      });
    },
    // query(id) {
    //   console.log(id,'sss')
    //   this.;
    // },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
         this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
        
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      // console.log(`当前页: ${val}`);
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
         this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
      });
    },
    Status(status) {
      // console.log(status, "uuu");
      if(status == 1){
        this.status = "有效"
      }else{
        this.status = "无效"
      }
      
      this.isTheme = status
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
         this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
      });
    },
    Addr(item, index) {
      // console.log(item, "sss");
      this.addr = item;

      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.isRegion = 0
          this.loading = false
        }else{
         this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
      });
      this.isRegion = index;
    },
    Year(item, index) {
      // console.log(item, "ddd");
      this.date = item;

      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.isYear = 0
          this.loading = false
        }else{
         this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
      });
      this.isYear = item;
    },
    Formats(item, index) {
      // console.log(item, index, "//////");
      this.mats = item;
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.isFormats = 0;
          this.loading = false
        }else{
         this.tableData = [];
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.statusList = res.status_count;
          this.currentPage = res.page;
        }
      });
    }
  },
  watch:{
    id(val){
      this.id = val
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
          this.tableData = []
          this.allCount = res.count;
          this.region = []
          this.year = [];
          this.formats = [];
          this.statusList = res.status_count;
          this.addr = "";
          this.date = "";
          this.mats = ""
        }
      });
    },
    name(val){
      this.name = val
      // console.log(this.name)
      let params = {
        base: this.addr, // 所属地区
        pub_year: this.date, // 发证年份
        subject_format: this.mats, // 主体业态
        status: this.status, // 状态码 0: 失效, 1: 有效
        company_name: this.name, // 经营者名称
        license_no: this.id, // 许可证编号
        page: this.page, // 页数
        pageSize: this.pageSize, // 每页条数
        order: this.order // 一共三种排序方式  status desc 有效状态  pub_date asc 发证时间升序 pub_date desc 发证时间降序
      };
      this.loading = true
      listSearch(params).then(res => {
        // console.log(res);
        if (res.msg == "查询成功") {
          this.tableData = res.data;
          // console.log(this.tableData);
          this.allCount = res.count;
          this.pageSize = res.pagesize;
          this.currentPage = res.page;
          this.region = res.region_count;
          this.statusList = res.status_count;
          // console.log(this.region, "////");
          this.year = res.year_count;
          this.formats = res.subject_count;
          this.loading = false
        }else{
          this.tableData = []
          this.allCount = res.count;
          this.region = []
          this.year = [];
          this.formats = [];
          this.statusList = res.status_count;
          this.addr = "";
          this.date = "";
          this.mats = ""
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#licenseWrap {
  position: relative;
  top: 0px;
  left: 0;
  bottom: 0;
  width: 100%;
  background: rgba(242, 245, 248, 1);
  .tabBar {
    width: 100%;
    height: 50px;
    background: rgba(19, 158, 255, 1);
    margin-bottom: 22px;
    .barCont {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      .barLeft {
        flex-grow: 1;
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 50px;
      }
      .barRight {
        position: relative;
        flex-grow: 0;
        display: inline-block;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 50px;
        :nth-child(1) {
          margin-right: 29px;
        }
        .line {
          position: absolute;
          top: 13px;
          left: 47px;
          width: 0.5px;
          height: 24px;
          background: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  .licContent {
    
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .licContTop {
      width: 1200px;
      background: rgba(255, 255, 255, 1);
      margin-bottom: 10px;
      .search {
        width: 90%;
        margin: 0 auto;
        padding-top: 50px;
        margin-bottom: 62px;
        img {
          display: inline-block;
          width: 318px;
          height: 69px;
        }
        .inp {
          position: relative;
          top: -15px;
          display: inline-block;
          height: 69px;
          margin-left: 30px;
          button {
            position: absolute;
            top: 29px;
            right: 0px;
            width: 88px;
            height: 40px;
            background: rgba(19, 158, 255, 1);
            color: #fff;
            font-size: 14px;
            font-weight: 500;
            border-radius: 0px;
            outline: none;
            border: 0px;
          }
          .tabName {
            display: inline-block;
            width: 94px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            &.active {
              background-color: #139eff;
              width: 94px;
              height: 30px;
              color: rgba(255, 255, 255, 1);
            }
          }
          .tabInput {
            width: 536px;
            height: 40px;
            border: 1px solid rgba(19, 158, 255, 1);
            display: none;
            padding-left: 20px;
            &.active {
              display: block;
            }
            input::-webkit-input-placeholder {
              color: #747474;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }
          }
          .el-tabs {
            width: 536px;
            display: inline-block;
            /deep/.el-tabs__header {
              display: inline-block;
              height: 100%;
              margin: 0px;
              .el-tabs__nav-wrap {
                margin-bottom: -9px;
                display: inline-block;
                .el-tabs__nav-scroll {
                  display: inline-block;
                  .el-tabs__item {
                    width: 94px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0px;
                    text-align: center;
                  }
                  .el-tabs__active-bar {
                    height: 0px;
                  }
                }
              }
              .el-tabs__nav-wrap::after {
                height: 0px;
              }
              .is-active {
                color: #fff;
                background-color: #108ee9;
              }
            }
            /deep/.el-tabs__content {
              display: inline-block;
              .el-tab-pane {
                width: 536px;
                height: 40px;
                .el-input {
                  width: 536px;
                  height: 40px;
                  .el-input__inner {
                    width: 536px;
                    height: 40px;
                    border-radius: 0px;
                  }
                }
              }
            }
          }
        }
      }
      .licForm {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 41px;
        .conditions {
          width: 100%;
          display: flex;
          height: 36px;
          span {
            font-size: 16px;
            font-weight: 700;
            color: rgba(55, 58, 60, 1);
            display: inline-block;
            line-height: 36px;
            height: 36px;
          }
          ul {
            display: inline-block;
            margin-left: 6px;
            li {
              position: relative;
              top: 0px;
              float: left;
              border: 1px solid rgba(19, 158, 255, 1);
              padding: 7px 31px 7px 9px;
              color: rgba(19, 158, 255, 1);
              font-size: 14px;
              font-weight: 400;
              margin-right: 10px;
              i {
                position: absolute;
                top: 7px;
                right: 9px;
                img {
                  width: 13px;
                  display: inline-block;
                }
              }
            }
          }
        }
        .region {
          width: 100%;
          margin-bottom: 10px;
          display: flex;
          span {
            font-size: 16px;
            font-weight: 700;
            color: rgba(55, 58, 60, 1);
          }
          ul {
            width: 980px;
            display: inline-block;
            margin-left: 6px;
            li {
              position: relative;
              top: 4px;
              float: left;
              font-size: 16px;
              font-weight: 400;
              color:rgba(116,116,116,1);
              font-family:PingFangSC-Regular,PingFang SC;
              margin-right: 28px;
            }
          }
        }
        .year {
          width: 100%;
          display: flex;
          margin-bottom: 10px;
          span {
            font-size: 16px;
            font-weight: 700;
            white-space: nowrap;
            color: rgba(55, 58, 60, 1);
          }
          ul {
            width: 980px;
            display: inline-block;
            margin-left: 6px;
            li {
              position: relative;
              top: 4px;
              float: left;
              font-weight: 400;
              color:rgba(116,116,116,1);
              font-size: 16px;
              font-family:PingFangSC-Regular,PingFang SC;
              margin-right: 28px;
            }
          }
        }
        .formats {
          width: 100%;
          margin-bottom: 10px;
          display: flex;
          span {
            font-size: 16px;
            font-weight: 700;
            white-space: nowrap;
            color: rgba(55, 58, 60, 1);
            line-height: 36px;
          }
          ul {
            width: 980px;
            display: inline-block;
            margin-left: 6px;
            line-height: 26px;
            li {
              position: relative;
              top: 4px;
              float: left;
              font-weight: 400;
              color:rgba(116,116,116,1);
              font-size: 16px;
              font-family:PingFangSC-Regular,PingFang SC;
              margin-right: 28px;
            }
          }
        }
        .theme {
          width: 100%;
          span {
            font-size: 16px;
            font-weight: 700;
            color: rgba(55, 58, 60, 1);
          }
          ul {
            width: 980px;
            display: inline-block;
            margin-left: 6px;
            .themeLi {
              cursor: pointer;
              position: relative;
              top: 4px;
              float: left;
              font-size:16px;
              font-weight: 400;
              color:rgba(116,116,116,1);
              font-family:PingFangSC-Regular,PingFang SC;
              margin-right: 28px;
            }
          }
        }
      }
    }
    .licContCen {
      width: 1200px;
      height: 86px;
      background: rgba(255, 255, 255, 1);
      margin-bottom: 10px;
      line-height: 86px;
      .contCen {
        width: 90%;
        margin: 0 auto;
        .result {
          float: left;
          font-size: 14px;
          font-weight: 400;
          color: rgba(55, 58, 60, 1);
          em {
            font-size: 18px;
            font-weight: 600;
            color: rgba(19, 158, 255, 1);
          }
        }
        .sort {
          float: right;
        }
      }
    }
    .licContFoot {
      width: 1200px;
      background: rgba(255, 255, 255, 1);
      .showInfo {
        img {
          margin: 0 auto;
          padding-bottom: 50px;
        }
      }
      /deep/.el-table {
        margin-bottom: 60px;
        // .el-table__body-wrapper{
        //   display: none;
        // }
        .el-table__header-wrapper {
          .has-gutter {
            tr {
              th {
                .cell {
                  font-size: 16px;
                  font-weight: 600;
                  color: rgba(55, 58, 60, 1);
                  text-align: center;
                }
              }
            }
          }
        }
      }
      /deep/.el-pagination {
        text-align: center;
        padding-bottom: 60px;
      }
    }
  }
}

.showM {
  width: 980px;
  height: 26px;
  overflow: hidden;
  display: inline-block;
  margin-left: 6px;
  line-height: 26px;
}

.trans {
  transform: rotate(-90deg);
  margin-bottom: 2px;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>